import { render, staticRenderFns } from "./templates-dynamic-fields-wrapper.vue?vue&type=template&id=66546f18&scoped=true&lang=pug"
import script from "./templates-dynamic-fields-wrapper.vue?vue&type=script&lang=js"
export * from "./templates-dynamic-fields-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66546f18",
  null
  
)

export default component.exports